import Environment from '../models/environment.model';

const LiveUS: Environment = {
  region: 'us',
  env: 'live',
  timezone: 'America/New_York',
  leapAuth: {
    clientId: 'FBSHVWGWT4BIQ3K7',
    oauthEndpoint: 'https://login.leap365.com',
    providerId: 'leap',
    userInfoUri: '/api/userinfo',
    authAgentUrl: 'https://cdn.test.leap.com.au/leap_auth/auth_agent/2.0.1/index.umd.js',
  },
  title: 'this is live us',
  reportingEndpoint: 'https://productivityreporting-api.us.leap365.com',
  reportingServiceEndpoint: 'https://productivity-reporting-services-api.us.leap365.com',

  helpCenterUrl: 'https://community.leap.us/s/',
  powerBILink: 'https://community.leap.us/s/article/Installing-Power-BI-LEAP-Connector-US',
  articleLinks: [
    {
      label: 'Available LEAP Reports',
      link: 'https://community.leap.us/s/article/Available-LEAP-Reports-US',
    },
    {
      label: 'About LEAP Reports',
      link: 'https://community.leap.us/s/article/Access-Reports',
    },
    {
      label: '10 Essential LEAP Reports',
      link: 'https://community.leap.us/s/article/10-Essential-LEAP-Reports-US',
    },
    {
      label: 'A Guide on Invoice-Related Reports',
      link: 'https://community.leap.us/s/article/A-Guide-On-Invoice-Related-Report-US',
    },
    {
      label: 'LEAP Reports - FAQs',
      link: 'https://community.leap.us/s/article/LEAP-Reports-FAQs-US',
    },
  ],
};

export default LiveUS;
